import React, { useState, useEffect } from "react";
import { Switch, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardUser from "./components/BoardUser";
import BoardAdmin_all from "./components/BoardAdmin_all";
import BoardAdmin_uw from "./components/BoardAdmin_uw";
import BoardAdmin_ug from "./components/BoardAdmin_ug";
import BoardAdmin_users from "./components/BoardAdmin_users";
import BoardDeviceContent from "./components/BoardDeviceContent";
import Charts from "./components/ChartsPower";
import ChartsStat from "./components/ChartsStatistic";


// import AuthVerify from "./common/AuthVerify";
import EventBus from "./common/EventBus";


const App = () => {
    const [showAdminBoard, setShowAdminBoard] = useState(false);
    const [currentUser, setCurrentUser] = useState(undefined);
    // const [currentUserRole, setCurrentUserRole] = useState({});

    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if (user) {
            // setCurrentUserRole({user:user.username,roles:user.roles[0]})

            setCurrentUser(user);
            setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
        }

        EventBus.on("logout", () => {
            logOut();
        });

        return () => {
            EventBus.remove("logout");
        };
    }, []);

    // console.log(currentUserRole)

    const logOut = () => {
        AuthService.logout();
        setShowAdminBoard(false);
        setCurrentUser(undefined);
    };



    const [phone, setPhone] = useState(false)

    const getWid = () => {
        let v = false
        if (document.documentElement.clientWidth < 600) v = true
        return (v)
    }
    useEffect(() => {
        setPhone(getWid())
        const resizeListener = () => { setPhone(getWid()) };
        window.addEventListener('resize', resizeListener);
        return () => { window.removeEventListener('resize', resizeListener); }
    }, [])

    const fsIPM = { fontSize: '1em' }
    const fsmenu = { fontSize: '0.8em' }

    return (
        <div>
            <nav style={{ height: '5vh', maxHeight: '156px' }}
                className="navbar navbar-expand navbar-dark bg-dark"
            >
                <Link className="navbar-brand" style={phone ? fsIPM : {}}>
                    IPM Develop s.r.o.
                </Link>

                {/* <div className="navbar-nav mr-auto" style={{ display: 'flex', flexWrap: 'wrap' }}> */}
                <div className="navbar-nav mr-auto">

                    {showAdminBoard && (
                        <>
                            <li className="nav-item">
                                <Link to={"/admin_all"} className="nav-link" style={phone ? fsmenu : {}}>
                                    All devices
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link to={"/admin_users"} className="nav-link" style={phone ? fsmenu : {}}>
                                    Users
                                </Link>
                            </li>
                        </>
                    )}

                    {(!showAdminBoard && currentUser) && (
                        <li className="nav-item">
                            <Link to={"/user"} className="nav-link" style={phone ? fsmenu : {}}>
                                Device
                            </Link>
                        </li>
                    )}
                </div>

                {currentUser ? (
                    <div className="navbar-nav ml-auto">
                        <li className="menulifs nav-item">
                            <a href="/login" className="nav-link" style={phone ? fsmenu : {}} onClick={logOut}>
                                LogOut
                            </a>
                        </li>
                    </div>
                ) : (
                    <div className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link to={"/login"} className="nav-link" style={phone ? fsmenu : {}}>
                                Login
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link to={"/register"} className="nav-link" style={phone ? fsmenu : {}}>
                                Sign Up
                            </Link>
                        </li>
                    </div>
                )}
            </nav>




            {/* <div className="container-fluid"> */}
            <div>
                <Switch>
                    <Route exact path={["/"]} component={Login} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/register" component={Register} />

                    <Route path="/user" component={BoardUser} />
                    <Route path="/device_content" component={BoardDeviceContent} />

                    {/* <Route path="/admin_all" component={BoardAdmin_all} /> */}
                    <Route path="/admin_all" component={()=><BoardAdmin_all user={currentUser}/>} />

                    <Route path="/admin_uw" component={BoardAdmin_uw} />
                    <Route path="/admin_ug" component={BoardAdmin_ug} />

                    {/* <Route path="/admin_users" component={BoardAdmin_users} /> */}
                    <Route path="/admin_users" component={()=><BoardAdmin_users user={currentUser}/>} />

                    <Route path="/charts" component={Charts} />
                    <Route path="/charts_stat" component={ChartsStat} />
                </Switch>
            </div>

            {/* <AuthVerify logOut={logOut}/> */}
        </div>
    );
};

export default App;
